exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_wks-ext.js
// module id = 146
// module chunks = 0